import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { User } from '@app/models/user.model';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-view-dialog',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
  ],
  standalone: true,
  templateUrl: './user-view-dialog.component.html',
  styleUrl: './user-view-dialog.component.scss',
})
export class UserViewDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<UserViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public user: User,
    private dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit(): void {
    // ...
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
